export default {
  INVALID_TOKEN: '@error-code/invalid-token',
  EXPIRED_TOKEN: "@error-code/token-expired",
  INVALID_JWT: '@error-code/invalid-jwt',
  USER_NOT_FOUND: '@error-code/user-not-found',
  DEACTIVATED_USER: '@error-code/deactivated-user',
  INVALID_CREDENTIALS: '@error-code/invalid-credentials',
  JWT_EXPIRED: '@error-code/jwt-expired',
  UNAUTHORIZED: '@error-code/unauthorized-action',
  RESOURCE_NOT_FOUND: '@error-code/resource-not-found',
  SKILL_HAS_GRADES: '@error-code/has-skill-grades',
  COURSE_HAS_NO_GRADE_DEFAULT_VIEW: '@error-code/this-course-has-no-grade-default-view',
  COURSE_TEMPLATE_SKILLS_HAVE_GRADES: '@error-code/course-template-skills-have-grades',
  GRADE_CATEGORY_HAVE_GRADABLE_ITEMS: '@error-code/one-or-more-categories-has-grades',
  COURSE_TEMPLATE_NOT_FOUND: '@error-code/course-template-not-found',
  TEMPLATE_NOT_LINKED_TO_THE_SAME_SUBJECT_OR_STAGE: '@error-code/template-not-linked-to-the-same-subject-or-same-stage'
};